document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.collection-carousel-section').forEach(function (section) {
      const track = section.querySelector('.collection-carousel__products');
      const prevBtn = section.querySelector('.collection-carousel__nav--prev');
      const nextBtn = section.querySelector('.collection-carousel__nav--next');
      const card = track.querySelector('.collection-carousel__product-card');
      if (!track || !prevBtn || !nextBtn || !card) return;

      // compute scroll-distance = one card width + the gap
      const style = window.getComputedStyle(track);
      const gap = parseInt(style.getPropertyValue('gap')) || 0;
      const step = card.offsetWidth + gap;

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: step, behavior: 'smooth' });
      });
    });
  });